import type { ReactNode } from 'react';

/**
 * A translated template with one `{placeholder}` swapped for a node, so the value keeps
 * its own styling (`num`, a link) while the words around it follow the language's word
 * order. `t()` interpolates strings only; this is the step for when the value is markup.
 */
export function fillTemplate(template: string, name: string, value: ReactNode): ReactNode {
  const [before, after = ''] = template.split(`{${name}}`);
  return (
    <>
      {before}
      {value}
      {after}
    </>
  );
}
